import request from '@/utils/sap-request'

// 材料计划查询
export const apiGetMaterialPlanList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materialquery',
    method: 'POST',
    data
  })
}

// 材料计划详情
export const apiGetMaterialPlanDetail = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materialpln_id',
    method: 'POST',
    data
  })
}

// 材料计划提交
export const apiGetMaterialPlanSub = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materialplnsubm',
    method: 'POST',
    data
  })
}

// 材料计划撤销
export const apiGetMaterialPlanUndo = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materialplnrvke',
    method: 'POST',
    data
  })
}

// 材料计划行项目删除
export const apiGetMaterialPlanItemDel = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materialplndele',
    method: 'POST',
    data
  })
}

// 材料计划行项目更新
export const apiGetMaterialPlanItemUpdate = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/m_plan_update',
    method: 'POST',
    data
  })
}

// 材料计划保存
export const apiGetMaterialPlanSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materialpln',
    method: 'POST',
    data
  })
}

// 可用材料报表查询
export const apiUsableMaterialReport = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/matertable',
    method: 'POST',
    data
  })
}

// 包材计划报表查询
export const apiPackageMaterialReport = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/packagingsch',
    method: 'POST',
    data
  })
}

// 材料计划汇总查询
export const apiMaterialPlanSumList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_matersumm',
    method: 'POST',
    data
  })
}

// 材料计划汇总确认
export const apiMaterialPlanSumSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/save_matersumm',
    method: 'POST',
    data
  })
}

// 材料计划包材确认/取消
export const apiMaterialPackageHandle = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/bc_matersumm',
    method: 'POST',
    data
  })
}

// 材料计划期初导入查询
export const apiMaterialInitImportList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materimport',
    method: 'POST',
    data
  })
}

// 材料计划期初导入保存数据检查
export const apiMaterialInitImportSavecheck = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materimportchck',
    method: 'POST',
    data
  })
}

// 材料计划期初导入保存
export const apiMaterialInitImportSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materimportsave',
    method: 'POST',
    data
  })
}

// 材料计划期初导入删除行
export const apiMaterialInitImportDel = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materimportdele',
    method: 'POST',
    data
  })
}

// 材料计划期初导入调整查询
export const apiMaterialChangeImportList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materadjust',
    method: 'POST',
    data
  })
}

// 材料计划期初导入调整保存数据检查
export const apiMaterialChangeImportSaveCheck = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materadjustchck',
    method: 'POST',
    data
  })
}

// 材料计划期初导入调整保存
export const apiMaterialChangeImportSave = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/materadjustsave',
    method: 'POST',
    data
  })
}

// 材料计划期初导入调整删除行
export const apiMaterialChangeImportDel = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/materadjustdele',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/sap/material-plan.js